import 'bootstrap';
import 'slick-carousel';
import './modules/carousels.js';
import './modules/burger-rotate.js';
import './modules/google-map.js';
import './modules/statistics-block.js';
import './modules/price-index-block.js';
import './modules/animations.js';
import './modules/chart.js';